import React from "react";
import Nav2 from "../Components/nav2/Nav2";
import TutOrang from "../Components/tutOrang/TutOrang";
import Contact from "../Components/contact/Contact";
import Footer from "../Components/footer/Footer";

const Tutoriels = () => {
  return (
    <div>
      <Nav2 />
      <TutOrang />
      <Contact />
      <Footer />
    </div>
  );
};

export default Tutoriels;
